import globalDomains from '@/utils/global-domains';
import styles from './SurveyHeader.module.scss';

const SurveyHeader = ({isDarkMode}: {isDarkMode: boolean}) => {
  const logoSrc = isDarkMode
    ? `${globalDomains.RES_AFREECATV}/images/svg/soop_logo_dark.svg`
    : `${globalDomains.RES_AFREECATV}/images/svg/soop_logo.svg`;
  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <a
          href={globalDomains.WWW_AFREECATV}
          className='logo_link'
          target='_blank'>
          <img src={logoSrc} alt='soop' />
        </a>
      </div>
    </div>
  );
};

export default SurveyHeader;
